module.exports = __webpack_public_path__ + "img/star.0589cf69.svg";